import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	teams: [],
	initialized: false,
};
